import { Navigate, Route } from "react-router-dom";
import CustomRoutePage from "./CustomRoutePage";

const CustomRoute = (page, parentPage) => {
  const currentPage = { ...page, parentPage };
  const { type, path, keyName, subPages = [], Layout, ...props } = page;

  let Content;
  if (type === "list") {
    Content = (
      <Route key={path} path={path} element={Layout}>
        <Route index element={<CustomRoutePage page={currentPage} />} />
        <Route path={`:${keyName}`}>
          {subPages.length > 0 && (
            <Route index element={<Navigate to={subPages[0].path} replace />} />
          )}
          {subPages.map((subPage) =>
            CustomRoute(subPage, {
              ...currentPage,
              type: "model",
              parentPage: currentPage,
            }),
          )}
          <Route path="*" element={<Navigate to={".."} replace />} />
        </Route>
        <Route path="*" element={<Navigate to={".."} replace />} />
      </Route>
    );
  } else {
    Content = (
      <Route key={path} path={`${path}`} element={Layout}>
        <Route index element={<CustomRoutePage page={currentPage} />} />
        {subPages.map((subPage) => CustomRoute(subPage, currentPage))}
        <Route path="*" element={<Navigate to={".."} replace />} />
      </Route>
    );
  }

  return Content;
};

export default CustomRoute;
